import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { ApiService } from './api.service';
import { Profile } from '../models';
import { profileApi } from '../../config';
import { AuthService } from './auth.service';

@Injectable()
export class ProfileService {
  constructor(
    private apiService: ApiService,
    private authService: AuthService
  ) {}

  getProfile(username: string): Observable<Profile> {
    return this.apiService.get(profileApi.getProfile + '?username=' + username);
  }

  getAllRoles(): any {
    return this.apiService.get(profileApi.getAllRoles);
  }

  updateProfile(userData: any): any {
    return this.apiService
      .putForAuth(profileApi.updateProfile + '/' + userData.id, userData)
      .pipe(
        map((data: any) => {
          const token = data.headers.get('SR-Authorization');
          this.setAuth(token);
          return data.body;
        })
      );
  }

  setAuth(token: string): void {
    this.authService.setToken(token);
  }

  postProfile(userData: any): any {
    return this.apiService
      .postForAuth(profileApi.updateProfile, userData)
      .pipe(
        map((data: any) => {
          const token = data.headers.get('SR-Authorization');
          this.setAuth(token);
          return data.body;
        })
      );
  }

  postProfilePic(profilePic: any, userId: any): any {
    return this.apiService.postForFile(
      profileApi.postProfilePic + '/' + userId,
      profilePic
    );
  }

  getEmailVerify(userId: any): any {
    return this.apiService.get(profileApi.getEmailVerify + userId);
  }

  resendApprovalEmail(userId: any, roleID: any): any {
    return this.apiService.get(
      profileApi.resendApprovalEmail + userId + '/role/' + roleID
    );
  }

  verifyEmail(token: any): any {
    return this.apiService.get(profileApi.verifyEmail + token);
  }

  approveUserRole(status: any, token: any): any {
    return this.apiService.get(
      profileApi.approveUserRole + status + '/' + token
    );
  }

  companyAllUsers(companyId: any): any {
    return this.apiService.get(profileApi.companyAllUsers + companyId);
  }

  updatePamProfile(body: any): any {
    return this.apiService
      .postForAuth(profileApi.updatePamProfile, body)
      .pipe(
        map((data: any) => {
          const token = data.headers.get('SR-Authorization');
          this.setAuth(token);
          return data.body;
        })
      );
  }

  approveChallenge(req: any): any {
    return this.apiService.post(profileApi.approveChallenge, req);
  }

  getWelecomePageData(userNm: any): any {
    return this.apiService.get(
      profileApi.getpamActivityData + '?username=' + userNm
    );
  }

  updateWelecomePageData(req: any): any {
    return this.apiService.post(profileApi.getpamActivityData + '?' + req);
  }

  getDataToken(): any {
    return this.apiService.get(profileApi.getDataToken);
  }

  setTokenUserName(action: any): any {
    return this.apiService.post(
      profileApi.setTokenUserName + '?name=' + action
    );
  }

  getpamActivityProgress(action: any): any {
    return this.apiService.get(
      profileApi.pamActivityProgress + '?username=' + action
    );
  }

  unsubscribeUser(req: any): any {
    return this.apiService.post(profileApi.unsubscribeUser + req);
  }

  getEmailNotificationType(id: any): any {
    return this.apiService.get(profileApi.emailNotificationType + id);
  }
}
